import fetch from 'isomorphic-fetch';

export default function PostData(type, userData) {

  let url = `${process.env.REACT_APP_API_HOST}webportal/`;
  return fetch(url + type, {
    method: 'POST',
    body: JSON.stringify(userData),
    credentials: 'include',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    },
  }).then(function (response) {
    const responseStatus = response.status;
    if (responseStatus === 200) {
      return response.json();
    }
    if (responseStatus === 403) {
      return this.setState({ invalidUserNameOrPassword: true });
    }
    return Promise.reject();
  });
}



// WEBPACK FOOTER //
// ./src/Services/ServAuthentication.jsx